<app-attendee-layout
  [backLinkAriaLabel]="'a11y.attendee.activity_detail.back_link' | translate"
  [backLink]="backLink"
>
  <article
    class="activity-component relative flex flex-col lg:grid lg:grid-cols-11"
  >
    <header class="flex flex-col lg:col-span-5 activity-component__header">
      <div>
        <app-activity-heading [activity]="activity"></app-activity-heading>
      </div>
    </header>

    <div class="mt-4 lg:col-span-5 lg:row-start-2">
      <app-attendee-activity-offers
        [timeslots]="timeslots"
        [activity]="activity"
      >
      </app-attendee-activity-offers>
    </div>
  </article>
</app-attendee-layout>
